/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import styles from './MiddleColumnSkeleton.module.scss';
import { Skeleton } from '@az/starc-ui';
import { FlexGrid } from '@/components/FlexGrid/FlexGrid';

export default function MiddleColumnSkeletonTop() {
  return (
    <>
      <div className={styles.container}>
        <FlexGrid flexDirection="column" gap={4}>
          <FlexGrid flexDirection="column" gap={2}>
            <FlexGrid flexDirection="column" gap={2}>
              <FlexGrid className={styles.productNameContainer}>
                <Skeleton className={styles.productName} />
                <Skeleton className={styles.share} />
              </FlexGrid>
              <Skeleton className={styles.productNameSecondLine} />
              <Skeleton className={styles.shopAll} />
            </FlexGrid>
            <FlexGrid>
              <Skeleton className={styles.sku} />
              <FlexGrid className={styles.stars} gap={1}>
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </FlexGrid>
              <Skeleton className={styles.reviewCount} />
            </FlexGrid>
            <FlexGrid gap={1}>
              <Skeleton className={styles.warrantyBadge} />
              <Skeleton className={styles.warranty} />
            </FlexGrid>
          </FlexGrid>
          <Skeleton className={styles.vehicleFitment} />
        </FlexGrid>
      </div>
    </>
  );
}
